import * as React from 'react';

import classNames from 'classnames';

import { Grid, Typography, Typography2 } from '@coursera/cds-core';

import ProductTypePill from 'bundles/browse/components/ProductTypePill';
import type { ProductTypeName } from 'bundles/browse/constants';
import { PRODUCT_TYPE_NAMES, getMappedProductTypeToDescription } from 'bundles/browse/constants';

import _t from 'i18n!nls/browse';

type Props = {
  /**
   * Use `productTypes` to specify which offers to display.
   * By default all the offers will be displayed.
   */
  productTypes?: ProductTypeName[];

  /**
   * Override the default mapProductTypesToDescription mapping.
   */
  productTypeToDescription?: { [key: string]: string };
  hideTitle?: boolean;
};

type TableRowProps = {
  firstElement: JSX.Element;
  secondElement: JSX.Element;
  wrapperClassName?: string;
};

const TableRow = ({ firstElement, secondElement, wrapperClassName }: TableRowProps) => (
  <tr className={classNames(wrapperClassName, 'table-row')}>
    <td className={classNames('first-column', 'table-content')}>
      <Typography2 component="span" variant="bodySecondary" className="span">
        {firstElement}
      </Typography2>
    </td>
    <td className={classNames('second-column', 'table-content')}>
      <Typography2 component="span" variant="bodySecondary" className="span">
        {secondElement}
      </Typography2>
    </td>
  </tr>
);

const OfferExplanationTable: React.FC<Props> = ({ productTypes, productTypeToDescription = {}, hideTitle }) => {
  const mapProductTypeToDescription = getMappedProductTypeToDescription();

  return (
    <Grid container>
      <section className="rc-OfferExplanationTable">
        {!hideTitle && (
          <Typography component="h2" variant="h2semibold" className="explanation-title">
            {_t('What Coursera Has to Offer')}
          </Typography>
        )}

        <table className="explanation-table" summary={_t('Table: What Coursera Has to Offer')}>
          <thead>
            <tr key="Offer-explanation-header" className="table-row table-header desktop-only-header">
              <th scope="col" className={classNames('table-header-first-column', 'first-column')}>
                <Typography2 component="span" variant="bodySecondary" className="span-title">
                  {_t('Learning program')}
                </Typography2>
              </th>
              <th scope="col" className="second-column">
                <Typography2 component="span" variant="bodySecondary" className="span-title">
                  {_t('Description')}
                </Typography2>
              </th>
            </tr>
          </thead>
          <tbody>
            {(productTypes ?? (Object.keys(mapProductTypeToDescription) as ProductTypeName[])).map(
              (productTypeName) => {
                return (
                  <TableRow
                    key={productTypeName}
                    firstElement={<ProductTypePill productTypeName={PRODUCT_TYPE_NAMES[productTypeName]} />}
                    secondElement={
                      <p className="top-skills-paragraph">
                        {productTypeToDescription[productTypeName] ?? mapProductTypeToDescription[productTypeName]}
                      </p>
                    }
                  />
                );
              }
            )}
          </tbody>
        </table>
      </section>
    </Grid>
  );
};

export default OfferExplanationTable;
